import { Helmet } from 'react-helmet-async';
import { Button, Typography, Box } from '@mui/material';
import { fullReload } from '../utils/fullReload';

export default function ErrorPage() {
  return (
    <>
      <Helmet>
        <title>Error | Platform Solutions</title>
      </Helmet>

      <Box sx={{ textAlign: 'center', alignItems: 'center', height: "max(300px, 100vh)", display: "flex", flexDirection: "column", justifyContent: "center" }}>  
        <Typography component="div" sx={{ color: 'text.secondary' }}>
          <Box>Sorry, something has gone wrong</Box>
          <Box>Please click the refresh button to reset the page</Box>
          <Box>If the refresh button does not help please email support@platformsolutions.com</Box>
        </Typography>

        <Button to="/" sx={{ mt: 4, mb: 4 }} variant="contained" onClick={fullReload}>
          Refresh 
        </Button>
      </Box>
    </>
  );
}
